img(v-if='imageNotFound' :src='`${staticFilesUri}/${fallbackImageName}`' @load='onLoad' @click='onClick(`${staticFilesUri}/${fallbackImageName}`)' data-test='fallback-image')
img(v-else :src='url' @load='onLoad' @error='onNotFoundImage' @click='onClick(url)' data-test='image')
